import React, { useEffect, useState } from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, BarChart, Bar } from "recharts";
import api from "@/lib/api";
import { money } from "@/context/StoreContext";
import { AdminCard } from "./AdminLayout";

export default function Analytics() {
  const [d, setD] = useState(null);
  const [days, setDays] = useState(30);
  useEffect(() => { api.get(`/admin/analytics?days=${days}`).then((r) => setD(r.data)).catch(() => {}); }, [days]);
  if (!d) return <p className="text-sharoa-muted">Loading…</p>;

  const csv = () => {
    const rows = [["Metric", "Value"], ["Revenue", d.revenue], ["Orders", d.orders], ["AOV", d.aov],
      ["COD Orders", d.cod_orders], ["Online Orders", d.online_orders], ["Return Rate %", d.return_rate], ["Refund Amount", d.refund_amount]];
    const blob = new Blob([rows.map((r) => r.join(",")).join("\n")], { type: "text/csv" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = "sharoa-analytics.csv"; a.click();
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="font-serif text-3xl">Analytics & Reports</h1>
        <div className="flex gap-2">
          <select value={days} onChange={(e) => setDays(Number(e.target.value))} className="border border-sharoa-line px-3 py-2 text-sm">
            <option value={7}>7 Days</option><option value={30}>30 Days</option><option value={90}>90 Days</option>
          </select>
          <button data-testid="export-csv" onClick={csv} className="bg-sharoa-charcoal text-white text-xs uppercase tracking-widest px-4">Export CSV</button>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        {[["Revenue", money(d.revenue)], ["Orders", d.orders], ["Avg Order Value", money(d.aov)], ["Return Rate", `${d.return_rate}%`],
          ["COD Orders", d.cod_orders], ["Online Orders", d.online_orders], ["Refund Amount", money(d.refund_amount)]].map(([l, v]) => (
          <AdminCard key={l}><span className="text-xs uppercase tracking-widest text-sharoa-muted">{l}</span><p className="font-serif text-2xl mt-1">{v}</p></AdminCard>
        ))}
      </div>
      <div className="grid lg:grid-cols-2 gap-4">
        <AdminCard>
          <h3 className="font-serif text-lg mb-4">Revenue Trend</h3>
          <ResponsiveContainer width="100%" height={240}>
            <LineChart data={d.daily}><XAxis dataKey="date" tick={{ fontSize: 10 }} hide /><YAxis tick={{ fontSize: 10 }} /><Tooltip /><Line type="monotone" dataKey="revenue" stroke="#D88A8A" strokeWidth={2} dot={false} /></LineChart>
          </ResponsiveContainer>
        </AdminCard>
        <AdminCard>
          <h3 className="font-serif text-lg mb-4">Top Products</h3>
          <ResponsiveContainer width="100%" height={240}>
            <BarChart data={d.top_products}><XAxis dataKey="name" tick={{ fontSize: 9 }} /><YAxis tick={{ fontSize: 10 }} /><Tooltip /><Bar dataKey="qty" fill="#D88A8A" /></BarChart>
          </ResponsiveContainer>
        </AdminCard>
      </div>
    </div>
  );
}
